import api from "@/lib/api";

export const LEVELS = [
  { value: "creche",    label: "Creche" },
  { value: "kg",        label: "Kindergarten" },
  { value: "primary",   label: "Primary" },
  { value: "jhs",       label: "Junior High" },
  { value: "shs",       label: "Senior High / High School" },
  { value: "vocational",label: "Vocational" },
  { value: "college",   label: "College" },
  { value: "university",label: "University" },
];

export const schoolsApi = {
  list: (params) => api.get("/schools", { params }).then(r => r.data),
  detail: (id) => api.get(`/schools/${id}`).then(r => r.data),
  filters: () => api.get("/schools/filters").then(r => r.data),
  match: (payload) => api.post("/schools/match", payload).then(r => r.data),

  // admin
  adminList: () => api.get("/admin/schools").then(r => r.data),
  adminCreate: (b) => api.post("/admin/schools", b).then(r => r.data),
  adminUpdate: (id, b) => api.patch(`/admin/schools/${id}`, b).then(r => r.data),
  adminDelete: (id) => api.delete(`/admin/schools/${id}`).then(r => r.data),
  adminAction: (id, action) => api.post(`/admin/schools/${id}/action`, { action }).then(r => r.data),
  // Assign / update the headteacher email that grants access to the school's
  // Headteacher portal (school_system_module handles auth via email match).
  assignHeadteacher: (id, email, name) =>
    api.post(`/school-system/schools/${id}/assign-headteacher`,
             { email, name }).then(r => r.data),
};

export function fmtFees(s) {
  if (s?.fees_min == null && s?.fees_max == null) return "Fees on request";
  const cur = s.fees_currency || "USD";
  if (s.fees_min && s.fees_max && s.fees_min !== s.fees_max) {
    return `${cur} ${Number(s.fees_min).toLocaleString()}–${Number(s.fees_max).toLocaleString()} / yr`;
  }
  const v = s.fees_min ?? s.fees_max;
  return `${cur} ${Number(v).toLocaleString()} / yr`;
}
